import React, {
  createContext,
  useContext,
  useMemo,
  useReducer,
  Reducer,
} from 'react';
import reducer from './reducer';
import Prompts from './index.d';

export const getInitialState = (): Prompts.ContextState => ({
  activePrompt: null,
  activePromptPayload: null,
});

export const PromptsContext = createContext<Prompts.ContextProps>([
  getInitialState(),
  // @ts-ignore {actions are initialized in `PromptsProvider`}
  () => {},
]);
PromptsContext.displayName = 'PromptsContext';

export function usePromptsContext(): Prompts.ContextProps {
  return useContext(PromptsContext);
}

export const PromptsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [state, dispatch] = useReducer<
    Reducer<Prompts.ContextState, Prompts.ContextActions>
  >(reducer, getInitialState());
  const promptsContextValue: Prompts.ContextProps = useMemo(
    () => [state, dispatch],
    [state, dispatch]
  );

  return (
    <PromptsContext.Provider value={promptsContextValue}>
      {children}
    </PromptsContext.Provider>
  );
};
